import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CallService } from 'src/app/services/call.service';

@Component({
    selector: 'app-fac-popup',
    templateUrl: './fac-popup.component.html',
    styleUrls: ['./fac-popup.component.css'],
    standalone: false
})
export class FacPopupComponent implements OnInit {

  responseForm : any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private call: CallService,
    public dialogRef: MatDialogRef<FacPopupComponent>,
  ) {
    console.log('[FacPopup] Constructor - Dialog abierto');
    console.log('[FacPopup] data.process (cc):', this.data?.process);
    console.log('[FacPopup] data.form presente:', !!this.data?.form);
  }

  ngOnInit(): void {
    console.log('[FacPopup] ngOnInit - Asignando HTML del banco al iframe');
    this.responseForm = this.data.form;
    console.log('[FacPopup] responseForm asignado:', !!this.responseForm);
  }

  exit() {
    const url = this.call.HOST + "/creditcard/" + this.data.process;
    console.log('[FacPopup] exit() - iframe cargó. Verificando proceso en:', url);

    this.call.get(url).subscribe(process =>{
      console.log('[FacPopup] Respuesta de /creditcard:', JSON.stringify(process.result));
      console.log('[FacPopup] process.result.verified:', process.result.verified);

      if(process.result.verified){
        console.log('[FacPopup] >>> VERIFICADO - Cerrando dialog con verified:', process.result.verified);
        this.dialogRef.close(process.result.verified);
      } else {
        console.log('[FacPopup] >>> NO VERIFICADO AÚN - El iframe sigue cargando/procesando. No se cierra el dialog.');
      }
    }, err =>{
      console.error('[FacPopup] >>> ERROR en GET /creditcard:', err);
      console.log('[FacPopup] Cerrando dialog sin resultado por error');
      this.dialogRef.close();
    })

  }

}
